class Mapper {
    static ToNombreArchivoExport(concepto: string): string {
        const now = new Date()
        const year = now.getFullYear()
        const month = (now.getMonth() + 1).toString().padStart(2, '0')
        const day = now.getDate().toString().padStart(2, '0')

        const dateStr = `${year}${month}${day}`
        return `SISCRED-${concepto}-${dateStr}`
    }
}

export default Mapper
